import { render, staticRenderFns } from "./questionnaireplan.vue?vue&type=template&id=64c32534&scoped=true&"
import script from "./questionnaireplan.vue?vue&type=script&lang=js&"
export * from "./questionnaireplan.vue?vue&type=script&lang=js&"
import style1 from "./questionnaireplan.vue?vue&type=style&index=1&id=64c32534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c32534",
  null
  
)

export default component.exports